import { render, staticRenderFns } from "./AdminTab.vue?vue&type=template&id=5589eb4c&"
import script from "./AdminTab.vue?vue&type=script&lang=js&"
export * from "./AdminTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports